import React, { forwardRef, useImperativeHandle, useState } from "react";
import CardLayout from "../common/CardLayout";
import CategoryDetails from "../categoryDetails/CategoryDetails";

export default forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        setItems: setItems,
        hide: hide,
        show: show
    }));

    const [incomeSummary, setIncomeSummary] = useState([]);
    const [visible, setVisible] = useState(true);

    const hide = () => {
        setVisible(false);
    };

    const show = () => {
        setVisible(true);
    };

    const setItems = (items) => {
        setIncomeSummary(items);
    };

    return visible ? (
        <CardLayout header={"פירוט הכנסות"}>
            <CategoryDetails height={310} items={incomeSummary} categoryWasClicked={props.incomeCategoryWasClicked} />
        </CardLayout>
    ) : (
        <div />
    );
});
